import { useDroppable } from '@dnd-kit/core'
import clsx from 'clsx'
import { useContext } from 'react'
import styled from 'styled-components'

import DraggedItemHeightContext from './DraggedItemHeightContext'

import useDelayedTogglingBoolean from 'hooks/useDelayedTogglingBoolean'
import { rem } from 'polished'

const Root = styled.div`
  height: ${rem(10000)}; // Arbitrary large height that will always be larger than the max-height

  &.animateHeight {
    transition: max-height 150ms ease-in-out;
  }
`

interface Props {
  id: string
  disabled?: boolean
}

function ItineraryDroppable({ id, disabled }: Props) {
  const { isOver, setNodeRef, active } = useDroppable({
    id,
    disabled,
  })

  const draggedItemHeight = useContext(DraggedItemHeightContext)

  // Delay enabling animations, so when the user first picks up an item the droppable
  // will expand instantly, but when they drag over other droppables it will animate.
  const animateHeight = useDelayedTogglingBoolean(!!active, {
    onDelay: 100,
  })

  return (
    <Root
      data-droppableid={id}
      ref={setNodeRef}
      style={{
        maxHeight: isOver ? draggedItemHeight : 0,
      }}
      className={clsx({ animateHeight })}
    >
    </Root>
  )
}

export default ItineraryDroppable
